var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tinymce',{attrs:{"setup":_vm.setup,"setting":_vm.setting}})
}
var staticRenderFns = []

export { render, staticRenderFns }